export { default as CmsMediaSwitch } from './CmsMediaSwitch';
